export default __webpack_public_path__ + "static/media/question-papers.db5fda7b.png";